import { render, staticRenderFns } from "./MasterMenuApiSubMenu.vue?vue&type=template&id=38d3d08e&scoped=true"
import script from "./MasterMenuApiSubMenu.vue?vue&type=script&lang=js"
export * from "./MasterMenuApiSubMenu.vue?vue&type=script&lang=js"
import style0 from "./MasterMenuApiSubMenu.vue?vue&type=style&index=0&id=38d3d08e&prod&lang=scss"
import style1 from "./MasterMenuApiSubMenu.vue?vue&type=style&index=1&id=38d3d08e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d3d08e",
  null
  
)

export default component.exports